import React from 'react';
import {
  Card,
  CardContent,
  Typography,
  Box,
  Grid
} from '@mui/material';

interface CostMetric {
  id: number;
  value: string;
  label: string;
}

const CostAnalysis: React.FC = () => {
  const costMetrics: CostMetric[] = [
    {
      id: 1,
      value: 'KSh 45',
      label: 'Cost per pupil/day'
    },
    {
      id: 2,
      value: 'KSh 22.5M',
      label: 'Daily budget'
    },
    {
      id: 3,
      value: 'KSh 157.5M',
      label: 'Weekly budget'
    },
    {
      id: 4,
      value: '-8.2%',
      label: 'Under budget'
    },
    {
      id: 5,
      value: 'KSh 38',
      label: 'Avg ingredient cost'
    },
    {
      id: 6,
      value: 'KSh 7',
      label: 'Labor cost/pupil'
    }
  ];

  return (
    <Card sx={{ mb: 3, boxShadow: '0 10px 30px rgba(0,0,0,0.2)', borderRadius: 3 }}>
      <CardContent>
        <Typography variant="h6" gutterBottom sx={{ mb: 3 }}>
          Cost Analysis & Budget
        </Typography>

        <Grid container spacing={2}>
          {costMetrics.map((metric) => (
            <Grid item xs={12} sm={6} md={2} key={metric.id}>
              <Box
                sx={{
                  background: 'linear-gradient(135deg, #17a2b8, #138496)',
                  color: 'white',
                  p: 2,
                  borderRadius: 2,
                  textAlign: 'center'
                }}
              >
                <Typography variant="h5" sx={{ fontWeight: 'bold', mb: 0.5 }}>
                  {metric.value}
                </Typography>
                <Typography variant="body2" sx={{ opacity: 0.9 }}>
                  {metric.label}
                </Typography>
              </Box>
            </Grid>
          ))}
        </Grid>
      </CardContent>
    </Card>
  );
};

export default CostAnalysis;
